import { Routes } from "@angular/router";
import { MainComponent } from "./layouts/main/main.component";
import { AuthGuard } from "./auth.guard";
import { HomeComponent } from "./pages/content/home/home.component";
import { InPlayComponent } from "./pages/content/in-play/in-play.component";
import { SportsBarComponent } from "./pages/sports-bar/sports-bar.component";
import { SportsComponent } from "./pages/sports-bar/sports/sports.component";
import { MarketComponent } from "./pages/content/market-layout/market/market.component";
import { NavigationItemComponent } from "./pages/sports-bar/navigation-item/navigation-item.component";
import { BetsComponent } from "./pages/user-pages/report/bets/bets.component";
import { PagesComponent } from "./pages/pages.component";
import { MyAccountComponent } from "./pages/user-pages/my-account/my-account.component";
import { StatementComponent } from "./pages/user-pages/report/statement/statement.component";
import { BettingPlComponent } from "./pages/user-pages/report/betting-pl/betting-pl.component";
import { DepositComponent } from "./pages/user-pages/deposit/deposit.component";
import { WithdrawComponent } from "./pages/user-pages/withdraw/withdraw.component";
import { WalletTransferComponent } from "./pages/user-pages/wallet-transfer/wallet-transfer.component";
import { ContentComponent } from "./pages/content/content.component";
import { SportHighlightsComponent } from "./pages/content/home/sport-highlights/sport-highlights.component";
import { InPlayMarketsComponent } from "./pages/content/in-play/in-play-markets/in-play-markets.component";
import { TodayMarketsComponent } from "./pages/content/in-play/today-markets/today-markets.component";
import { TomorrowMarketsComponent } from "./pages/content/in-play/tomorrow-markets/tomorrow-markets.component";
import { SearchResultsComponent } from "./pages/search-results/search-results.component";
import { BetSlipComponent } from "./pages/betting-manager/bet-slip/bet-slip.component";
import { OpenBetsComponent } from "./pages/betting-manager/open-bets/open-bets.component";
import { MarketLayoutComponent } from "./pages/content/market-layout/market-layout.component";
import { BlankComponent } from "./layouts/blank/blank.component";
import { MarketLiquidityComponent } from "./pages/content/components/market-liquidity/market-liquidity.component";
import { MarketUpdateDebuggerComponent } from "./pages/content/components/market-update-debugger/market-update-debugger.component";
import { MyMarketsComponent } from "./pages/content/my-markets/my-markets.component";
import { SingleMarketViewComponent } from "./pages/content/market-layout/single-market-view/single-market-view.component";
import { SportPageComponent } from "./pages/content/sport-page/sport-page.component";
import { IpMarketsTabComponent } from "./pages/content/sport-page/tabs/ip-markets-tab/ip-markets-tab.component";
import { CompetitionsTabComponent } from "./pages/content/sport-page/tabs/competitions-tab/competitions-tab.component";
import { LeaguesSubTabComponent } from "./pages/content/sport-page/tabs/competitions-tab/leagues-sub-tab/leagues-sub-tab.component";
import { CountriesSubTabComponent } from "./pages/content/sport-page/tabs/competitions-tab/countries-sub-tab/countries-sub-tab.component";
import { UpcomingTabComponent } from "./pages/content/sport-page/tabs/upcoming-tab/upcoming-tab.component";
import { UpcomingSubTabComponent } from "./pages/content/sport-page/tabs/upcoming-tab/upcoming-sub-tab/upcoming-sub-tab.component";

export const routes: Routes = [
  {
    path: "app",
    component: PagesComponent,
    canActivate: [AuthGuard],
    children: [
      { path: "", redirectTo: "main", pathMatch: "full" },
      {
        path: "main",
        component: MainComponent,
        children: [
          {
            path: "",
            component: SportsBarComponent,
            outlet: "navigation",
            children: [
              {
                path: "sports",
                component: SportsComponent,
              },
              {
                path: ":type/:id",
                component: NavigationItemComponent,
              },
              { path: "", redirectTo: "sports", pathMatch: "full" },
            ],
          },
          {
            path: "",
            component: ContentComponent,
            outlet: "content",
            children: [
              {
                path: "home",
                component: HomeComponent,
                children: [
                  {
                    path: "highlights",
                    component: SportHighlightsComponent,
                  },
                  {
                    path: "highlights/:sport",
                    component: SportHighlightsComponent,
                  },
                  {
                    path: "",
                    redirectTo: "highlights/cricket",
                    pathMatch: "full",
                  },
                ],
              },
              {
                path: "in-play",
                component: InPlayComponent,
                children: [
                  { path: "current", component: InPlayMarketsComponent },
                  { path: "today", component: TodayMarketsComponent },
                  { path: "tomorrow", component: TomorrowMarketsComponent },
                  {
                    path: "",
                    redirectTo: "current",
                    pathMatch: "full",
                  },
                ],
              },
              { path: "my-markets", component: MyMarketsComponent },
              {
                path: ":sport",
                component: SportPageComponent,
                children: [
                  { path: "in-play", component: IpMarketsTabComponent },
                  { path: "popular", component: SportHighlightsComponent, data: { type: "popular" } },
                  {
                    path: "upcoming",
                    component: UpcomingTabComponent,
                    children: [
                      { path: "date/:date", component: UpcomingSubTabComponent },
                      { path: "", redirectTo: "date/today", pathMatch: "full" },
                    ],
                  },
                  {
                    path: "competition",
                    component: CompetitionsTabComponent,
                    children: [
                      { path: "leagues", component: LeaguesSubTabComponent },
                      { path: "countries", component: CountriesSubTabComponent },
                      { path: "", redirectTo: "leagues", pathMatch: "full" },
                    ],
                  },
                  { path: "league/:leagueId/:leagueName", component: SportHighlightsComponent },
                  { path: "", redirectTo: "in-play", pathMatch: "full" },
                ],
              },
              {
                path: "event-markets/:eventId",
                component: MarketLayoutComponent,
                children: [
                  {
                    path: "market/:marketId",
                    component: SingleMarketViewComponent,
                  },
                ],
              },
              { path: "market/:marketId", component: MarketComponent },
              { path: "", redirectTo: "home", pathMatch: "full" },
            ],
          },
          {
            path: "",
            component: OpenBetsComponent,
            outlet: "betting",
          },
        ],
      },
      { path: "my-account", component: MyAccountComponent },
      { path: "slip-settings", component: BetSlipComponent },
      {
        path: "bets",
        component: BetsComponent,
      },
      {
        path: "statement",
        component: StatementComponent,
      },
      {
        path: "betting-pl",
        component: BettingPlComponent,
      },
      {
        path: "deposit",
        component: DepositComponent,
      },
      {
        path: "withdraw",
        component: WithdrawComponent,
      },
      {
        path: "wallet-transfer",
        component: WalletTransferComponent,
      },
      {
        path: "search-data/:page/:size/:keyword",
        component: SearchResultsComponent,
      },
    ],
  },
  {
    path: "",
    component: BlankComponent,
    children: [
      {
        path: "",
        loadChildren: () => import("./pages/authentication/authentication.module").then((m) => m.AuthenticationModule),
      },
    ],
  },
  { path: "market-liquidity/:marketId/:selectionId", component: MarketLiquidityComponent },
  { path: "market-debugger/:marketId", component: MarketUpdateDebuggerComponent },
  {
    path: "**",
    redirectTo: "authentication/error",
  },
];
